// @ts-nocheck

import { AnimationsActionTypes } from '../types/actions/animations';

export const animationsInitialState = {
  oddsTravel: [],
};

export const actionTypesToReactOn = [AnimationsActionTypes.ODDS_TRAVEL_PUSH, AnimationsActionTypes.ODDS_TRAVEL_POP];

const animationsReducer = (state = animationsInitialState, action) => {
  const { type, payload = {} } = action;

  if (actionTypesToReactOn.indexOf(type) !== -1) {
    if (type === AnimationsActionTypes.ODDS_TRAVEL_PUSH) {
      const { oddId, sourceElementUuid, ts, emoji } = payload;
      const { oddsTravel } = state;
      const nextOddsTravel = [
        ...oddsTravel,
        {
          oddId,
          sourceElementUuid,
          emoji,
          ts,
        },
      ];

      return {
        ...state,
        oddsTravel: nextOddsTravel,
      };
    }

    if (type === AnimationsActionTypes.ODDS_TRAVEL_POP) {
      const { oddId, sourceElementUuid, ts } = payload;
      const { oddsTravel } = state;
      const nextOddsTravel = oddsTravel.filter(
        ({ oddId: animOddId, sourceElementUuid: animSourceElementUuid, ts: animTs }) =>
          animOddId !== oddId || animTs !== ts || animSourceElementUuid !== sourceElementUuid,
      );

      return {
        ...state,
        oddsTravel: nextOddsTravel,
      };
    }
  }

  return state;
};

export default animationsReducer;
